import * as React from 'react';
import { Button, ButtonProps } from './button';

export const ButtonSecondary = (props: ButtonProps) => {
  const { children, ...rest } = props;
  return (
    <Button btnType="btn-secondary" {...rest}>
      {children}
    </Button>
  );
};
